import { Box, Typography } from '@mui/material';

/**
 * The properties for the welcome section component
 */
interface WelcomeSectionProps {
  /**
   * The title of the welcome section
   */
  title: string;
  /**
   * The children of the welcome section
   */
  children: JSX.Element | JSX.Element[];
}

/**
 * A component that represents a section within the welcome step
 */
const WelcomeSection = (props: WelcomeSectionProps) => (
  <Box width="100%" marginBottom="2em">
    <Typography fontSize="1.3em" fontWeight="bold" gutterBottom>
      {props.title}
    </Typography>
    {props.children}
  </Box>
);

export default WelcomeSection;
